export default {
  title: 'Card Image Title Text'
}

const Template = args => `
  <cradlepoint-container max-width="600px">
    <cradlepoint-card-image-title-text type="${args['type']}" use-bg-on-image="${args['useBgOnImage']}" bg-color="${args['bgColor']}" text-align="${args['textAlign']}" bg-image="${args['bgImage']}" linked-in="${args['linkedIn']}" new-tab="${args['newTab']}"
    >
      ${args['title'] && args['title']}
      ${args['content'] && args['content']}
      ${args['cta'] && args['cta']}
    </cradlepoint-card-image-title-text>
  </cradlepoint-container>
`;

export const IconWithBgAlignDefault = Template.bind({});
export const IconWithBgAlignRight = Template.bind({});
export const IconWithBgAlignCenter = Template.bind({});
export const ImageWithHover = Template.bind({});
export const ImageLarge = Template.bind({});
export const Leadership = Template.bind({});

IconWithBgAlignDefault.args = {
  type: 'icon-with-bg',
  useBgOnImage: 'true',
  bgColor: 'var(--cwc-color-primary, #FFAD00)',
  textAlign: 'left',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2019/12/ss_icon3.png',
  title: `<h3 slot="title">Simple and sophisticated</h3>`,
  content: `<p slot="text">Cellular broadband goes up immediately and with ease — especially with <a href="https://cradlepoint.com/resources/blog/how-zero-touch-deployment-of-routers-impacts-lean-it/">zero-touch deployment</a> through Cradlepoint’s plug-and-play solutions. And with <a href="https://cradlepoint.com/products/netcloud-service/">Cradlepoint NetCloud</a>, real-time network visibility and control are at your fingertips.</p>`,
  cta: `<cradlepoint-button-cta
      slot="cta"
      text-color="white"
      text-color-hover="var(--cwc-color-accent-b, #008EAA)"
      background-color="var(--cwc-color-accent-b, #008EAA)"
      background-color-hover="white"
      border-color="var(--cwc-color-accent-b, #008EAA)"
      link="#"
      style="margin-left:0"
      class="mr-auto"
    >
      Learn More
    </cradlepoint-button-cta>`,
  linkedIn: '',
  newTab: 'true'
}

IconWithBgAlignRight.args = {
  type: 'icon-with-bg',
  useBgOnImage: 'true',
  bgColor: 'var(--cwc-color-primary, #FFAD00)',
  textAlign: 'right',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2020/01/bulletproof-icon.png',
  title: `<h3 slot="title">Secure and reliable</h3>`,
  content: `<p slot="text">Have the peace of mind that comes from reliable, high-performance connectivity through wireless solutions with integrated security. Thousands of enterprises count on <a href="https://cradlepoint.com/resources/blog/5-benefits-of-cloud-managed-routers-for-wireless-wan/">cloud-managed routers</a>&nbsp;and adapters for WWAN and private cellular networks every day.</p>`,
  cta: `<a slot="cta" href="#">Learn More</a>`,
  linkedIn: '',
  newTab: 'true'
}

IconWithBgAlignCenter.args = {
  type: 'icon-with-bg',
  useBgOnImage: 'true',
  bgColor: 'var(--cwc-color-primary, #FFAD00)',
  textAlign: 'center',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2020/01/icon-t1.webp',
  title: `<h3 slot="title">Versatile and scalable</h3>`,
  content: `<p slot="text">With the broadest range of use cases and solutions, Cradlepoint offers the flexibility to embrace new ways of doing business anywhere, and to always put your best network forward. We provide scalability suited to fast-moving business transformation.</p>`,
  cta: `<cradlepoint-button-cta
      slot="cta"
      link="#"
    >
      Learn More
    </cradlepoint-button-cta>`,
  linkedIn: '',
  newTab: 'true'
}

ImageWithHover.args = {
  type: 'image-with-hover',
  useBgOnImage: 'true',
  bgColor: 'var(--cwc-color-primary, #FFAD00)',
  textAlign: 'left',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2022/05/Retail@2x-new.webp',
  title: `<h3 slot="title">Versatile and scalable</h3>`,
  content: `<p slot="text">With the broadest range of use cases and solutions, Cradlepoint offers the flexibility to embrace new ways of doing business anywhere, and to always put your best network forward. We provide scalability suited to fast-moving business transformation.</p>`,
  cta: `<a slot="cta" href="#">Learn More</a>`,
  linkedIn: '',
  newTab: 'true'
}

ImageLarge.args = {
  type: 'image-large',
  useBgOnImage: '',
  bgColor: '',
  textAlign: 'center',
  bgImage: 'https://cdn.pathfactory.com/assets/10933/thumbnails/691121/94e8f511-b350-4e31-8652-35eb12774d8f.jpg',
  title: '',
  content: '',
  cta: `<a slot="cta" href="#">How LTE and 5G Wireless WAN Can Transform Fixed and Temporary Locations</a>`,
  linkedIn: '',
  newTab: 'true'
}

Leadership.args = {
  type: 'leadership',
  useBgOnImage: '',
  bgColor: '',
  textAlign: 'center',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2023/11/asa-tamsons-360x420-1.png',
  title: `<h3 slot="title">Åsa Tamsons</h3>`,
  content: `<p slot="text">Head of Business Area Enterprise Wireless Solutions, Ericsson</p>`,
  cta: '',
  linkedIn: 'https://www.linkedin.com/in/asatamsons/',
  newTab: false
}
